import { useReviewQueueFilters } from "./ap-url-state";
import { useApForwarding } from "./query/forwarding";
import { useGetReviewQueue } from "./query/lists";
import { flattenPages } from "./utils";

export const useForwardingEmptyState = (
  businessId: string | null,
  onReviewTab: boolean,
) => {
  const { filtered } = useReviewQueueFilters();
  const enabledBusiness = onReviewTab && !filtered ? businessId : null;
  const { data: reviewQueue, isError: reviewQueueError } =
    useGetReviewQueue(enabledBusiness);
  const {
    data: forwarding,
    isError: forwardingError,
    isFetchedAfterMount: forwardingFetchedAfterMount,
  } = useApForwarding(enabledBusiness);

  return Boolean(
    onReviewTab &&
      !filtered &&
      !reviewQueueError &&
      reviewQueue &&
      flattenPages(reviewQueue.pages).length === 0 &&
      !forwardingError &&
      forwardingFetchedAfterMount &&
      forwarding?.has_processed_invoices === false,
  );
};
